export function AffiliateDisclosure() {
  return (
    <div className="rounded-md border border-blush/60 bg-blush-soft/70 px-3 py-2 text-xs leading-relaxed text-plum">
      <strong className="font-semibold">Affiliate disclosure:</strong> KnowMeno may
      earn a small commission when you buy through the links on this page, at no
      extra cost to you. We only feature products we believe could help women in
      perimenopause and menopause. This is not medical advice — talk to your
      clinician before starting new supplements or treatments.
    </div>
  );
}
